import { render, staticRenderFns } from "./ActBerdiskusi.vue?vue&type=template&id=21588cfa&"
import script from "./ActBerdiskusi.vue?vue&type=script&lang=js&"
export * from "./ActBerdiskusi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports